import {Button} from '@chekinapp/ui';
import {useTranslation} from 'react-i18next';
import {MapPin, QrCode} from 'lucide-react';
import {ArrivalHintSheet} from '../arrival/ArrivalHintSheet';

type Props = {
  open: boolean;
  onClose: () => void;
  onBackToStart?: () => void;
};

const POINTS = [
  {icon: QrCode, i18nKey: 'identity-verification:invalid_qr_use_the_printed_sticker'},
  {icon: MapPin, i18nKey: 'identity-verification:invalid_qr_check_the_right_door'},
];

export function InvalidQRModal({open, onClose, onBackToStart}: Props) {
  const {t} = useTranslation('identity-verification');

  return (
    <ArrivalHintSheet
      open={open}
      onClose={onClose}
      title={t('invalid_qr_modal.title')}
      description={t('invalid_qr_modal.description')}
      points={POINTS}
    >
      <Button className="w-full" onClick={onClose}>
        {t('invalid_qr_modal.try_again')}
      </Button>
      {onBackToStart && (
        <Button variant="outline" className="w-full" onClick={onBackToStart}>
          {t('invalid_qr_modal.back_to_start')}
        </Button>
      )}
    </ArrivalHintSheet>
  );
}
